var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card_block",on:{"click":_vm.toDetails}},[_c('div',{staticClass:"start_layout"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.item.noticeTitle))])]),_c('div',{staticClass:"bottom_area"},[_vm._m(0),_c('div',{staticStyle:{"margin-left":"5px"}},[_vm._v(_vm._s(_vm.item.createTime))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('i',{staticClass:"el-icon-time icon"})])
}]

export { render, staticRenderFns }